import { render, staticRenderFns } from "./BreweryMap.vue?vue&type=template&id=3df85c26&scoped=true&"
import script from "./BreweryMap.vue?vue&type=script&lang=js&"
export * from "./BreweryMap.vue?vue&type=script&lang=js&"
import style0 from "./BreweryMap.vue?vue&type=style&index=0&id=3df85c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df85c26",
  null
  
)

export default component.exports